export default "__VITE_ASSET__C1WcdkL9__"